import styled from 'styled-components'
import WorldWide from 'images/icons/general-contacts/worldwide.inline.svg'

export const Wrapper = styled.div(({theme}) => ({}))

export const WorldIcon = styled(WorldWide)(({theme}) => ({
  marginRight: 8,
}))
